import { CartLinesUpdateEvent } from '@shopify/events';

const CR_TIMER_KEY = 'cr_cart_timer_end';
const crRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

/* Cuenta atras: '¡Sus productos estan reservados para MM:SS!' */
class CrCartTimer extends HTMLElement {
  connectedCallback() {
    this.clock = this.querySelector('[data-cr-timer-clock]');
    this.minutes = Number(this.dataset.minutes) || 10;
    this.end = this.readEnd();
    this.tick();
    this.interval = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);
  }

  readEnd() {
    const now = Date.now();
    let end = 0;
    try {
      end = Number(window.localStorage.getItem(CR_TIMER_KEY)) || 0;
    } catch (error) {}
    if (!end || end <= now) {
      end = now + this.minutes * 60000;
      try {
        window.localStorage.setItem(CR_TIMER_KEY, String(end));
      } catch (error) {}
    }
    return end;
  }

  tick() {
    if (this.end <= Date.now()) this.end = this.readEnd();
    const left = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
    const minutes = String(Math.floor(left / 60)).padStart(2, '0');
    const seconds = String(left % 60).padStart(2, '0');
    if (this.clock) this.clock.textContent = `${minutes}:${seconds}`;
  }
}

/* Carrusel 'Te encantaran estos' con boton Anadir */
class CrCartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const arrow = target.closest('[data-cr-upsell-dir]');
    if (arrow) {
      const track = this.querySelector('[data-cr-upsell-track]');
      if (track) {
        const dir = Number(arrow.getAttribute('data-cr-upsell-dir')) || 1;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        const atStart = track.scrollLeft <= 4;
        if (dir > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
        else if (dir < 0 && atStart) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        else track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
      }
      return;
    }

    const button = target.closest('[data-cr-upsell-add]');
    if (button instanceof HTMLButtonElement) this.add(button);
  };

  async add(button) {
    if (button.disabled) return;
    const card = button.closest('[data-cr-upsell-card]');
    const input = card ? card.querySelector('[data-cr-upsell-variant]') : null;
    const variantId = input ? input.value : '';
    if (!variantId) return;

    const label = button.textContent;
    button.disabled = true;
    button.textContent = '...';
    this.setError('');

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const response = await fetch(`${crRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'No se pudo añadir el producto');

      const cart = await fetch(`${crRoot()}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'cr-cart-upsell',
          sourceId: 'cr-cart-upsell',
          itemCount: 1,
          sections: data.sections,
          didError: false,
        },
      });
    } catch (error) {
      deferred.reject(error);
      button.disabled = false;
      button.textContent = label;
      this.setError(error instanceof Error ? error.message : 'No se pudo añadir el producto');
    }
  }

  setError(message) {
    const el = this.querySelector('[data-cr-upsell-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }
}

if (!customElements.get('cr-cart-timer')) customElements.define('cr-cart-timer', CrCartTimer);
if (!customElements.get('cr-cart-upsell')) customElements.define('cr-cart-upsell', CrCartUpsell);
